import { lazyRouteComponent } from "@tanstack/react-router";

export const MapRoute = lazyRouteComponent(() => import("./routes/map"), "MapRoute");
export const LiveDetectionsRoute = lazyRouteComponent(
  () => import("./routes/live-detections"),
  "LiveDetectionsRoute",
);
export const AccountPage = lazyRouteComponent(
  () => import("./routes/account"),
  "AccountPage",
);
export const PreferencesRoute = lazyRouteComponent(
  () => import("./routes/preferences"),
  "PreferencesRoute",
);
export const GeofencesRoute = lazyRouteComponent(
  () => import("./routes/geofence/geofences"),
  "GeofencesRoute",
);
export const GeofenceCreateRoute = lazyRouteComponent(
  () => import("./routes/geofence/geofence-create"),
  "GeofenceCreateRoute",
);
export const GeofenceDetailRoute = lazyRouteComponent(
  () => import("./routes/geofence/geofence-detail"),
  "GeofenceDetailRoute",
);
export const GeofenceEditRoute = lazyRouteComponent(
  () => import("./routes/geofence/geofence-edit"),
  "GeofenceEditRoute",
);
export const GeofenceViolationsRoute = lazyRouteComponent(
  () => import("./routes/geofence/geofence-violations"),
  "GeofenceViolationsRoute",
);
export const FlightRestrictionZonesRoute = lazyRouteComponent(
  () => import("./routes/flight-restriction/flight-restriction-zones"),
  "FlightRestrictionZonesRoute",
);
export const FlightRestrictionZoneDetailRoute = lazyRouteComponent(
  () => import("./routes/flight-restriction/flight-restriction-zone-detail"),
  "FlightRestrictionZoneDetailRoute",
);
export const FlightRestrictionZoneMapRoute = lazyRouteComponent(
  () => import("./routes/flight-restriction/flight-restriction-zone-map"),
  "FlightRestrictionZoneMapRoute",
);
export const FlightRestrictionZoneViolationsRoute = lazyRouteComponent(
  () => import("./routes/flight-restriction/flight-restriction-zone-violations"),
  "FlightRestrictionZoneViolationsRoute",
);
export const FlightPlanSubmissionRoute = lazyRouteComponent(
  () => import("./routes/flight-plan/flight-plan-submission"),
  "FlightPlanSubmissionRoute",
);
export const FlightPlansRoute = lazyRouteComponent(
  () => import("./routes/flight-plan/flight-plans"),
  "FlightPlansRoute",
);
export const FlightPlanDetailRoute = lazyRouteComponent(
  () => import("./routes/flight-plan/flight-plan-detail"),
  "FlightPlanDetailRoute",
);
export const LoginPage = lazyRouteComponent(
  () => import("./routes/login"),
  "LoginPage",
);
export const SubscriptionsRoute = lazyRouteComponent(
  () => import("./routes/subscriptions"),
  "SubscriptionsRoute",
);
export const PrivacyPolicyRoute = lazyRouteComponent(
  () => import("./routes/privacy-policy"),
  "PrivacyPolicyRoute",
);
export const TermsOfUseRoute = lazyRouteComponent(
  () => import("./routes/terms-of-use"),
  "TermsOfUseRoute",
);
export const SupportPage = lazyRouteComponent(
  () => import("./routes/support"),
  "SupportPage",
);
